import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { MenuService } from '../../../../services/menu.service';
import { ConfigService } from '../../../../services/config.service';
import { LogService } from '../../../../services/log.service';
import { DataIoService } from '../../../../services/data-io.service';
import { TranslationService } from '../../../../services/translation.service';
import { LoadinganimationComponent } from '../loadinganimation/loadinganimation.component';
import { Helper, MenuNode, BaseSensor, ISensorInterface } from '../../../../classes';
import { ValueChangedConfirmation } from '../../../../classes/ValueChangedConfirmation';
import { TextinputComponent } from '../../../helpers/textinput/textinput.component';

@Component({
    selector: 'screen-showvalue',
    templateUrl: './show-value.component.html',
    styleUrls: ['./show-value.component.scss']
})

export class ShowValueComponent implements OnInit {
    @Input('debug') debug: false;
    enabled_buttons: Array<string>;
    title: string = "";
    subTitle: string = "";
    currentNode: MenuNode=null;
    unit: string = "STD_UNIT_CELSIUS_NORMAL_LEFT";
    min: number;
    max: number;
    _value: any;
    _sensor : BaseSensor;
    get value():any{
        return this._value;
    }

    set value(v:any){
        this._value = v;
    }


    steps: number = 0.1;
    dashIcon: string = "";
    buttonSubscription$: any;
    showMarker = false;
    showTexts = false;
    showTextInput = false;
    darkTitle = false;
    brightText = false;
    brightText1 = false;
    brightText2 = false;
    brightText3 = false;
    numberStyle = "int";
    type: string;
    pans=0;
    panSkip=4;
    _valueLeft=0;
    valueLeft="0%"
    constructor(
        private menuService: MenuService, 
        private ioService: DataIoService, 
        private logger: LogService, 
        private config: ConfigService, 
        private translator:TranslationService) {
        this.currentNode = menuService.getCurrentNode();
    }

    isBlinking: boolean;
    // blinkende werte (code falsch eingegeben)
    blinkValue() {
        this.isBlinking = true;
        setTimeout(() => {
            this.isBlinking = false;
        }, 1000);
    }

    changed=false;
    // blinkende buttons (z.B. nach veränderung)
    blink(){
        if(!this.changed){
            this.changed = true;
            this.menuService.blinkButton('confirm');
        }
    }
    temperatureForTimeFrameEventHandler(event) {
        if (event != "confirm") {
            this.menuService.resetTimeout();
        }
        switch (event) {
            
            case 'confirm': {

                let timeframe = this.ioService.getCurrentTimeFrame();
                this.ioService.currentTimeFrame.setValue(this.value);
                let zone = this.menuService.getCurrentNode().get('zone');
                let day = this.menuService.getCurrentNode().get('day');
                let table = this.menuService.getCurrentNode().get('table');
                if(table == 'heating'){
                    timeframe.setIgnoreTemperature(false);
                }
                let mode = this.menuService.getCurrentNode().get('mode');
                if (mode == "add") {
                    this.ioService.deviceInfo().getZoneById(parseInt(zone)).getTimeFrameManager(table).addTimeFrame(timeframe);
                }
                if (mode == "edit") {
                    let id = this.menuService.getCurrentNode().get('id');

                    let tfm = this.ioService.deviceInfo().getZoneById(parseInt(zone)).getTimeFrameManager(table);
                    if (tfm) {
                        tfm.patch(parseFloat(id), timeframe);
                    } else {
                        this.logger.debug("TimeFrame-Manager is null.");
                    }
                }
                let cnfmtn = new ValueChangedConfirmation('timeframe','0','1',this.menuService.getCurrentNode());
                if(this.menuService.getCurrentNode().hasTarget()){
                    let target = this.menuService.getCurrentNode().getTargetNode();
                    if(target){
                        this.menuService.goto(target,cnfmtn);
                        return;
                    }
                }
                
                if(!this.menuService.historyBack(cnfmtn)){
                    this.menuService.hierarchyUp(false,cnfmtn);
                    return;
                }else{
                    return;
                }
            }
            case 'back': {
                this.backClicked();
                return;
            }
            case 'question':{
                this.menuService.showHelp();
                return;
            }
        }
    }
    backClicked(){

        this.logger.debug("Back clicked.");
        if(this.menuService.getCurrentNode().hasBackTarget()){
            this.logger.debug("Goto backtarget ");
            let backTarget = this.menuService.getCurrentNode().getBackTargetNode()
            
            this.logger.debug("Backtarget is: "+backTarget.getTitle());
            this.menuService.goto(backTarget);
            return;
        }

        if (this.menuService.getCurrentNode().getType() == "code") {
            this.logger.debug("Goto hierarchy up");
            this.menuService.hierarchyUp();
            return;
        }
        this.logger.debug("Goto history back");
        if(!this.menuService.historyBack()){
            this.logger.debug("failed. going hierarchy up");
            this.menuService.hierarchyUp();
            return;
        }
    }
    temperatureEventHandler(event) {
        //this.panSkip=1;
        if (event != "confirm") {
            this.menuService.resetTimeout();
        }

        switch (event) {
            case 'question':{
                this.menuService.showHelp();
                return;
            }
            case 'confirm': {
                
                if (this.menuService.getCurrentNode().getType() == "code") {
                    if (parseInt(this.getValue()) != parseInt(this.ioService.deviceInfo().getScaleValue('code').toString())) {
                        this.logger.debug("this.getValue:" + this.getValue() + " does not match " + this.ioService.deviceInfo().getScaleValue('code'));
                        this.blinkValue();
                        return;
                    }
                }
                let confirmation = this.menuService.currentNode.onConfirm(this.value);
                if (this.menuService.currentNode.hasTarget()) {
                    let target = this.menuService.currentNode.getTargetNode();
                    if (target) {
                        this.menuService.goto(target,confirmation);
                        return;
                    }
                }
                return;
            }
            case 'back': {
                this.backClicked();
                return;
            }
        }
    }


    hasParameter(p:string):boolean{
        return this.menuService.hasParameter(p);
    }
    currentChar: any;
    currentCharChanged(char) {
        this.logger.debug("Current char changed to " + char);
        if (char === undefined) {
            return;
        }
        if (char == "") {
            this.currentChar = false;
        } else {
            this.currentChar = char;
        }
    }

    saveText(text) {
        if (text != undefined && text != null) {
            let confirmation = this.menuService.currentNode.onConfirm(text);
            this.menuService.hierarchyUp(confirmation);
        } else {
            this.logger.debug("Text is undefined in onSave-Listener.");
        }
    }

    textChanged(text) {
        if (text == undefined) {
            this.logger.debug("text changed to undefined.");
            return;
        }
        this.value = text;
        this.updateValueLeft();
    }

    // abstand nach links..
    updateValueLeft(){
        if(this.value.length > 9){
            this._valueLeft = (this.value.length -9);
            
        }else{
            this._valueLeft=0;
        }
        this.valueLeft = (-0.75*this._valueLeft)+"em";
    }
    stringEventHandler(event) {

        if (event != "confirm") {
            this.menuService.resetTimeout();
        }
        // textinput kümmert sich um den rest.
        switch (event) {
            case 'back': {
                this.logger.debug("Going back in history.");
                this.menuService.historyBack();
                return;
            }
            case 'question':{
                this.menuService.showHelp();
                return;
            }
        }
    }
    get lightTitle(){
        return this.hasParameter('lightTitle');
    }
    get lightSubtitle(){
        return this.hasParameter('lightSubtitle');
    }

    ngOnInit() {
        if (this.menuService.hasParameter('zeitprogrammassistent')) {
            this.darkTitle = true;
            this.brightText = true;
        }
        if(this.menuService.hasParameter('brightText')){
            this.brightText = true;
        }
        if(this.menuService.hasParameter('brightText1')){
            this.brightText1 = true;
        }
        if(this.menuService.hasParameter('brightText2')){
            this.brightText2 = true;
        }
        if(this.menuService.hasParameter('brightText3')){
            this.brightText3 = true;
        }
        this.type = this.menuService.currentNode.getType();
        this.menuService.onElementFocused(this.menuService.getCurrentNode());
        switch (this.type) {
            case 'temperature': {
                this.configureTemperatureSetter();
                return;
            }
            case 'numberstring': {

            }
            case 'string': {
                this.configureStringSetter();
                return;
            }
            case 'timeframe-temperature': {
                this.timeframeTemperatureSetter();
                return;
            }
            case 'changecode': {

            }
            case 'code': {
            }
            case 'number': {
                this.defaultSetup();
                this.value = this.menuService.getCurrentNode().getValue();
                this.unit = "";
                this.numberStyle = "twodigit";
                this.steps = 1;
                this.min = 0;
                this.max = 99;
                if (this.value == 0) {
                    this.value = "00";
                }
                break;
            }
            default: {
                this.defaultSetup();
            }
        }

    }

    defaultSetup() {
        //this.panSkip = 5;
        this.title = this.menuService.currentNode.getTitle();
        this.subTitle = this.menuService.getCurrentNode().getSubTitle();
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.temperatureEventHandler(event); }
        );
        this.showMarker = true;
        this.showTexts = true;


        this.showTextInput = false;
        let sensor = this.menuService.currentNode.getOnConfirmTarget();



        
        
        if (sensor instanceof BaseSensor) {
            this.unit = sensor.getUnit();
            this.steps = sensor.getGranularity();
            this.min = sensor.getMinValue();
            this.max = sensor.getMaxValue();
            this.value = (sensor.getCurrentValue());
            this._sensor = sensor;
            if (this.steps <= 0.1) {
                this.numberStyle = "twodecimals";
            }
        } else {
            this.unit = "STD_UNIT_CELSIUS_NORMAL_LEFT";
            this.steps = 0.1;
            this.max = 30;
            this.min = 5;
        }
    }
    ngOnDestroy() {
        this.buttonSubscription$.unsubscribe();
    }

    getValue() {

        if (this.type == "numberstring" || this.type == "string") {
            return this.value;
        }
        if(this._sensor instanceof BaseSensor){
            if(this._sensor.hasSpecialValue(this.value)){
                this.logger.debug("current value is special.");
                return this._sensor.toString();
            }else{
                this.logger.debug("has no special value for "+this.value);
            }
        }else{
            this.logger.debug("has no sensor.");
        }
        
        if (parseInt(this.steps.toString()) == this.steps) { // ganzzahlig.
            if (this.type == "code" || this.type == "changecode") {
                return Helper.twoDigits(this.value);
            }
            return this.value;
        }
        if (this.steps < 1 && this.steps >= 0.1) {
            return this.value.toFixed(1);
        }
        return this.value.toFixed(2);

        /*
        if (typeof (this.value) == "number") {

            if (parseInt(this.value.toString()).toString() == this.value.toString()) {
                return this.value.toString() + ".0";
            } else {
                return this.value.toString();
            }
        }

        switch (this.numberStyle) {
            case 'twodigit': {
                return Helper.twoDigits(this.value);
            }
            case 'twodecimals': {
                let intPart = parseInt(this.value);
                return intPart + "." + Helper.twoDigits((this.value - intPart) * 100);
            }
            default: {
                return this.value;
            }
        }
        */


    }
    getUnit() {
        if(this._sensor instanceof BaseSensor){
            if(!this._sensor.hasSpecialValue(this.value)){
                return this.translator.tr(this._sensor.getUnit());
            }
        }
        return this.translator.tr(this.unit);
    }
    configureStringSetter() {
        this.showMarker = false;
        this.showTexts = false;
        this.unit = "";
        this.value = this.menuService.currentNode.getValue();
        this.showTextInput = true;
        this.title = this.menuService.currentNode.getTitle();

        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.stringEventHandler(event); }
        );
    }

    timeframeTemperatureSetter() {
        //this.panSkip = 2 ;
        this.title = this.menuService.currentNode.getTitle();
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.temperatureForTimeFrameEventHandler(event); }
        );
        this.showMarker = true;
        this.showTexts = true;

        this.showTextInput = false;
        let sensor = this.menuService.currentNode.getOnConfirmTarget();
        if(sensor instanceof BaseSensor){
            this._sensor = sensor;
        }    
        this.value = parseInt(this.menuService.getCurrentNode().get('value'));
        this.logger.debug("Temperature Setter: ");
        this.logger.debug(this.value);
        this.unit = "STD_UNIT_CELSIUS_NORMAL_LEFT";
        this.steps = 0.5;
        this.max = 30;
        this.min = 5;
    }



    configureTemperatureSetter() {
        //this.panSkip=3;
        this.title = this.menuService.currentNode.getTitle();
        this.buttonSubscription$ = this.ioService.inputs.events$.subscribe(
            (event) => { this.temperatureEventHandler(event); }
        );
        this.showMarker = true;
        this.showTexts = true;

        this.showTextInput = false;

        let sensor = this.menuService.currentNode.getOnConfirmTarget();
        if (sensor instanceof BaseSensor) {
            this.logger.debug("Configuring with sensor: ");
            this.value = sensor.getCurrentValue();
            this.unit = sensor.getUnit();
            this.steps = sensor.getGranularity();
            this.max = sensor.getMaxValue();
            this.min = sensor.getMinValue();
            this._sensor = sensor;
        } else {
            if (this.menuService.getCurrentNode().getValue()) {
                this.value = this.menuService.getCurrentNode().getValue();
                this.unit = "STD_UNIT_CELSIUS_NORMAL_LEFT";
                this.steps = 0.5;
                this.min = 5;
                this.max = 30;
            }
        }
    }
}
